var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOnePoint01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "77.898 140.16 16 16",
    enableBackground: "new 77.898 140.16 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M85.898,140.16c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S90.309,140.16,85.898,140.16z  M85.898,155.16c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S89.757,155.16,85.898,155.16z M84.763,143.367 c-0.183-0.078-0.395-0.042-0.541,0.095l-2.143,2.008c-0.201,0.188-0.212,0.505-0.023,0.706c0.19,0.203,0.506,0.213,0.707,0.023 l1.301-1.219v7.013c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-8.167C85.064,143.627,84.946,143.447,84.763,143.367z  M87.898,149.326c-0.827,0-1.5,0.674-1.5,1.5c0,0.828,0.673,1.5,1.5,1.5s1.5-0.672,1.5-1.5 C89.398,150,88.725,149.326,87.898,149.326z M87.898,151.326c-0.275,0-0.5-0.224-0.5-0.5c0-0.275,0.225-0.5,0.5-0.5 s0.5,0.225,0.5,0.5C88.398,151.102,88.173,151.326,87.898,151.326z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnePoint01);
export default __webpack_public_path__ + "static/media/icon_one_point-01.23d2ae12cc07632657710a00703b202f.svg";
export { ForwardRef as ReactComponent };